// extracted by mini-css-extract-plugin
export default {"controls":"styles_controls__kbiZP","iconBtn":"styles_iconBtn__amdec","closeBtn":"styles_closeBtn__eU+9C","disabled":"styles_disabled__50jrL"};